import { useTranslation } from "react-i18next";
import { InputTextStyled } from "../../../../../style/Input";
import { FormRow } from "../../../../../style/form";
import { RowSpacer } from "../../../../../style/containers";
import { UserSubjectFormModel } from "./UserSubjectFormModel";
import InputFiscalCode from "../../../../Inputs/InputFiscalCode";
import { userManagement } from "../../../../../config/testIds";

interface IUserSubjectFormProps {
  model: UserSubjectFormModel;
  onChange: (value: any, field: string) => void;
}

const UserSubjectForm = (props: IUserSubjectFormProps) => {
  const { model, onChange } = props;

  const { t } = useTranslation();

  return (
    <>
      <FormRow>
        <InputTextStyled
          dataTestId={userManagement.userSubjectForm.inputName}
          label={`${t("edit-subject-tab-data-name")} *`}
          tooltip={t("edit-subject-tab-data-name-tooltip")}
          placeholder={t("edit-subject-tab-data-name-placeholder")}
          onChange={(name) => onChange(name, "name")}
          value={model.name}
        />
        
        <RowSpacer />

        <InputTextStyled
          dataTestId={userManagement.userSubjectForm.inputLastName}
          label={`${t("edit-subject-tab-data-lastname")} *`}
          tooltip={t("edit-subject-tab-data-lastname-tooltip")}
          placeholder={t("edit-subject-tab-data-lastname-placeholder")}
          onChange={(lastname) => onChange(lastname, "lastName")}
          value={model.lastName}
        />
      </FormRow>

      <FormRow>
        <InputFiscalCode
          dataTestId={userManagement.userSubjectForm.inputFiscalCode}
          onChange={(fiscalCode) =>
            onChange(fiscalCode.toUpperCase(), "fiscalCode")
          }
          value={model.fiscalCode}
          validation={{
            state: model.fiscalCodeValidation!.validateStatus === "success",
            messageKey: model.fiscalCodeValidation!.messageKey,
          }}
        />
      </FormRow>
    </>
  );
};

export default UserSubjectForm;
